import React from 'react'

import ChallengeCard from '../ChallengeCard'
import MyEventCard from '../MyEventCard'

export const DesignGameCard = props => {
  const isEvent = props.data.className === 'UserEvent'
  const Card = isEvent ? MyEventCard : ChallengeCard

  return <Card {...props} />
}
